import { Component, inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-new-country-dialog',
  templateUrl: './new-country-dialog.component.html',
  styleUrl: './new-country-dialog.component.scss',
})
export class NewCountryDialogComponent {
  readonly dialogRef = inject(MatDialogRef<NewCountryDialogComponent>);
  readonly fb = inject(FormBuilder);

  readonly countryForm = this.fb.group({
    country: [null, [Validators.required]],
  });

  closeWithSave() {
    const countryCode = this.countryForm.value.country!;
    this.dialogRef.close(countryCode);
  }
}
